const GwtTokenKey = "GwtTokenKey";

// TODO: Document it
class GwtTokenStorage {

  constructor() {
  }

  store(token) {
    window.localStorage.setItem(GwtTokenKey, token);
  }

  clear() {
    window.localStorage.removeItem(GwtTokenKey);
  }

  get() {
    return window.localStorage.getItem(GwtTokenKey);
  }
}

const instance = new GwtTokenStorage();
export default instance;